import { memo } from "react";

import styles from "./styles.module.scss";
import CustomLink from "@Components/CustomLink";
import wrapperHOC from "@Utils/wrapperHOC";

interface Props {
  items: any[];
}
const List = ({ items }: Props) => (
  <div className={styles.UserList}>
    <h4>User List</h4>
    <ul>
      {items.map((item, index) => (
        <li key={index}>
          <CustomLink to={`/places/search/${item.canonical_name}`}>
            {item.canonical_name}
          </CustomLink>
        </li>
      ))}
    </ul>
  </div>
);

export default wrapperHOC(memo(List), {
  componentName: "List-Global",
  showForChina: true,
});
